

































import { Component, Prop, Vue } from "vue-property-decorator";
import DoKoHtmlDialog from "../DoKoHtmlDialog.vue";
import DoKoBtn from "../../../components/controls/DoKoBtn.vue";

@Component({ components: { DoKoHtmlDialog, DoKoBtn } })
export default class DoKoRestrictionSoloQ extends Vue {}
